export namespace FunctionUtils {
  export type TCallback<T> = (value: T) => void;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  export function isFunction(value: any): value is Function {
    return typeof value === "function";
  }
}
